// src/pages/Blog.js
import React from "react";
import Blog from "../components/Blog";

export default function BlogPage() {
  return <Blog />; // or pass posts={...} popular={...}
}
